import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/SearchEngCampaignsSelectInfluencers.graphql';
import { Query, QuerysearchEngCampaignsSelectInfluencersArgs } from '../../__generated__/globalTypes';

export const useSearchEngCampaignsSelectInfluencersQuery = (
  options?: QueryHookOptions<Query, QuerysearchEngCampaignsSelectInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerysearchEngCampaignsSelectInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useSearchEngCampaignsSelectInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerysearchEngCampaignsSelectInfluencersArgs>
): QueryResult<Query, QuerysearchEngCampaignsSelectInfluencersArgs> & {
  getSearchEngCampaignsSelectInfluencers: LazyQueryExecFunction<Query, QuerysearchEngCampaignsSelectInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getSearchEngCampaignsSelectInfluencers, result] = useLazyQuery<
    Query,
    QuerysearchEngCampaignsSelectInfluencersArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getSearchEngCampaignsSelectInfluencers, ...result };
};

export const useSearchEngCampaignsSelectInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getSearchEngCampaignsSelectInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerysearchEngCampaignsSelectInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerysearchEngCampaignsSelectInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getSearchEngCampaignsSelectInfluencers };
};
// Suspense Query Hooks
export const useSearchEngCampaignsSelectInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerysearchEngCampaignsSelectInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerysearchEngCampaignsSelectInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
